import { server_ip } from "../config";

export async function fetchTransactions(token, filter, options , project=null) {
    try {
        const response = await fetch(`${server_ip}/api/transactions/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,
                options,
                ...project?{project}:{}
            })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}